<template>
    <v-dialog v-model="dialog" persistent scrollable max-width="500">
        <ValidationObserver ref="obs">
            <v-card>
                <v-progress-linear
                    v-if="isLoading"
                    indeterminate
                    color="primary"
                    rounded
                    height="6"
                ></v-progress-linear>

                <v-card-title class="pa-0 shadow-1">
                    <v-img
                        :src="
                            require('@/assets/illustrations/bg_modal_card.svg')
                        "
                        cover
                        position="left bottom"
                        class="align-center"
                        height="65px"
                    >
                        <v-card-title class="font-weight-medium primary--text">
                            Eliminar Registro de Campaña
                        </v-card-title>
                    </v-img>
                </v-card-title>

                <v-card-text style="max-height: 350px">
                    <v-form>
                        <v-row dense>
                            <v-col cols="12">
                                <v-card-title class="font-weight-medium ">
                                    Esta seguro que desea eliminar este registro
                                    de campaña
                                </v-card-title>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions class="mx-2">
                    <v-spacer></v-spacer>
                    <v-hover v-slot:default="{ hover }">
                        <v-btn
                            text
                            rounded
                            class="mr-1"
                            :color="hover ? 'error' : 'grey'"
                            @click="closeDialog(null)"
                        >
                            Cancelar
                        </v-btn>
                    </v-hover>

                    <v-hover v-slot:default="{ hover }">
                        <v-btn
                            rounded
                            :loading="isLoading"
                            :disabled="isLoading"
                            color="error"
                            :class="hover ? 'shadow-2' : 'shadow-4'"
                            class="px-8"
                            @click="deleteAction"
                        >
                            Eliminar
                        </v-btn>
                    </v-hover>
                </v-card-actions>
            </v-card>
        </ValidationObserver>
    </v-dialog>
</template>

<script>
export default {
    props: {
        dialog: {
            type: Boolean
        },
        axios: {
            type: Function
        },
        id: {
            type: Number
        }
    },
    data() {
        return { isLoading: false };
    },
    methods: {
        closeDialog(id) {
            this.$emit("dialog:close", id);
        },
        async deleteAction() {
            this.isLoading = true;
            try {
                await this.axios.delete(`/campaign/register/${this.id}`);
                this.$snotify.success(
                    "Se ha eliminado el registro de campaña correctamente",
                    "¡Hecho!"
                );
                this.closeDialog(this.id);
            } catch (err) {
                this.$snotify.error(
                    "Ha ocurrido un error eliminando el registro campaña",
                    "¡Error!"
                );
            }
            this.isLoading = false;
        }
    }
};
</script>

<style></style>
